import { div, anchor } from "../../shared/dom";
import { App } from "./app";
import { Auth } from "./auth";

export class IndexPage {

  static render_main(container: HTMLElement) {
    container.innerHTML = "";
    const d = div("viz-index");
    container.appendChild(d);
    Auth.render_signup(container);
  }

  static render_nav(nav: HTMLElement) {
    nav.innerHTML = "";
    const login = anchor("nav-a");
    login.innerText = "Sign In";
    login.href = "/login";
    nav.appendChild(div("spacer"));
    nav.appendChild(login);
    App.enable_link(login);
  }
}